export default {
    backVisible: true,
    saveVisible: true,
    nextVisible: true,
    backLabel: 'Vissza',
    saveLabel: 'Mentés',
    nextLabel: 'Tovább',
    tabsDisabled: false,
    backIcon: null,
    saveIcon: null,
    nextIcon: null,
    onBeforeSave: null,
    onBeforeNext: null,
    onBeforeBack: null,
};
